import { createFileRoute } from '@tanstack/react-router';
import { ContactTasksPage } from '@/components/organisms/contacts/ContactTasksPage';

export const Route = createFileRoute('/_dashboard/dashboard/contacts/tasks')({
  component: ContactTasksPage,
});
